'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sellerPublicComponent = undefined;

var _marked = require('marked');

var _marked2 = _interopRequireDefault(_marked);

var _markedRenderer = require('./../../common/core/markedRenderer');

var _markedRenderer2 = _interopRequireDefault(_markedRenderer);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_marked2.default.setOptions({
    renderer: _markedRenderer2.default,
    breaks: false,
    sanitize: true
});
var sellerPublicComponent = exports.sellerPublicComponent = {
    template: require('./public.html'),
    bindings: {
        seller: '<',
        sellerPublic: '<'
    },
    controllerAs: 'vm',
    controller: ["$rootScope", "Enums", "$state", "common", "Analytics", "gettextCatalog", function controller($rootScope, Enums, $state, common, Analytics, gettextCatalog) {
        'ngInject';

        var vm = this;
        vm.$onChanges = bindingChanges;
        vm.$onInit = init;
        vm.bannerTextAlignmentClasses = Enums.bannerTextAlignmentClasses;
        vm.sellerLogos = [];

        //todo put in service/enum
        vm.heroSliderSettings = {
            autoplay: true,
            autoplaySpeed: 6000,
            dots: true,
            draggable: false,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            responsive: [{
                breakpoint: 576,
                settings: {
                    dots: true,
                    arrows: false
                }
            }]
        };

        function init() {
            if (!vm.seller) {
                $state.go('error');
            }

            common.setTitle(vm.seller.name);
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/' + vm.seller.id + '/public', vm.seller.name + ' ' + gettextCatalog.getString('public'));
            vm.sellerLogos = _lodash2.default.groupBy(_lodash2.default.orderBy(vm.sellerPublic.sellerLogos, ['partnershipType', 'priority']), 'partnershipTypeName');
        }

        function bindingChanges(changes) {
            if (changes.sellerPublic) {
                if (changes.sellerPublic.currentValue) {
                    vm.sellerPublic = Object.assign(changes.sellerPublic.currentValue, {
                        content: (0, _marked2.default)(changes.sellerPublic.currentValue.content || ''),
                        contactContent: (0, _marked2.default)(changes.sellerPublic.currentValue.contactContent || '')
                    });
                } else {
                    vm.sellerPublic = changes.sellerPublic.currentValue;
                }
            }
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/seller/public.js
// module id = 1027
// module chunks = 0